import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useReloadOnShareExit = () => {
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;
    const previousPath = previousPathRef.current;

    if (previousPath.includes('/shares/') && !currentPath.includes('/shares/')) {
      window.location.reload();
    }

    previousPathRef.current = currentPath;
  }, [location]);
};

export default useReloadOnShareExit;
